<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-traceabilities-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-traceabilities-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-traceabilities-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                                  [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                                  [filters]="filters" [disableRouterLink]="true">
    </app-traceabilities-list>
  </ng-template>
</div>